import HelpHub from './HelpHub';

/** @deprecated route alias — single Help hub */
export default function MultiPageDocs() {
  return <HelpHub initialSection='start' />;
}
